module.exports = __webpack_public_path__ + "static/media/RectangleShape.ee376171.svg";